import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=fd09db14&scoped=true&"
import script from "./CustomHeader.vue?vue&type=script&lang=js&"
export * from "./CustomHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd09db14",
  null
  
)

export default component.exports